import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import { UtilService } from './util';


@Injectable({
  providedIn: 'root'
})
export class WfService {
  url = `${environment.urlApiProtheus}/wsrwf`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService,
  ) {}

  postAtualizacaoCadastroEnviaEmail(tipo: string, id: number) {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post(`${this.url}/atualizacaocadastro/${tipo}/${id}`, {} , httpOptions);
  }

}
